<template>
    <div class="editor-container flex flex-direction">
        <Toolbar
            :defaultConfig="toolbarConfig"
            :editor="editor"
            :mode="mode"
            style="border-bottom: 1px solid #ccc"
        />
        <Editor
            v-model="cvalue"
            :defaultConfig="editorConfig"
            :mode="mode"
            :style="`height: ${height}`"
            class="ck-editor"
            @onChange="onChange"
            @onCreated="onCreated"
        />
    </div>
</template>

<script>

import {ckEditConfig} from "@/config/editor";
import {Editor, Toolbar} from '@wangeditor/editor-for-vue'

export default {
    name: "CkBasicEditor",
    emits: ['input', 'update:modelValue', 'change'],
    components: {
        Editor, Toolbar
    },
    data() {
        return {
            editor: null,
            cvalue: '',
            toolbarConfig: {
                excludeKeys: ['codeBlock', 'emotion']
            },
            mode: 'default', // or 'simple'
            editorConfig: ckEditConfig(),
        }
    },
    props: {
        value: {
            type: [Array, String, Number],
            default() {
                return ''
            }
        },
        modelValue: {
            type: [Array, String, Number],
            default() {
                return '';
            }
        },
        height: {
            type: [String, Number],
            default() {
                return '370px'
            }
        }
    },
    computed: {
        dataValue() {
            if (this.value === '') return this.modelValue
            if (this.modelValue === '') return this.value
            return this.value
        }
    },
    mounted() {
        this.cvalue = this.getValue()
        console.log(this.cvalue)
        this.init()
    },
    methods: {
        init() {

        },
        onCreated(editor) {
            this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
        },
        onChange() {
            if (this.editor.isEmpty()) this.cvalue = ''
            this.$emit('input', this.cvalue);
            this.$emit('update:modelValue', this.cvalue);
        },
        getValue() {
            if (this.value === '') return this.modelValue
            if (this.modelValue === '') return this.value
            return this.value
        }
    },
    beforeDestroy() {
        this.editor && this.editor.destroy() // 组件销毁时，及时销毁编辑器
    },
    watch: {
        modelValue(newVal) {
            if (newVal !== '') {
                if (!this.editor.getText()) this.cvalue = newVal
            }
        },
        value(newVal) {
            if (newVal !== '') {
                if (!this.editor.getText()) this.cvalue = newVal
            }
        },
    }
}
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<style lang="scss">
.editor-container {
    border-radius: 10px;
    border: 1px solid #e9e9e9;
    padding: 0 10px;
    line-height: 1;

    .ck-editor {
        height: 500px;
        overflow-y: hidden;
    }
}
</style>